import { render, staticRenderFns } from "./PartnersComponent.vue?vue&type=template&id=706f8f22&scoped=true"
import script from "./PartnersComponent.vue?vue&type=script&lang=js"
export * from "./PartnersComponent.vue?vue&type=script&lang=js"
import style0 from "./PartnersComponent.vue?vue&type=style&index=0&id=706f8f22&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706f8f22",
  null
  
)

export default component.exports